<template>
    <div>
        <VuePhoneNumberInput
            v-model="telefono"
            :data-cy="dataCy"
            :disabled="desactivar"
            :border-radius="0"
            :translations="translations"
            size="lg"
            id="phone"
            @update="formatNumber"
            @blur="tocado = true"
            @input="handleInput"
            class="mb-1"
        />
        <span
            v-if="mostrarErrorFormato"
            class="invalid-feedback mb-4 mt-0 mt-md-3 text-xs"
            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
        >
            <b>{{ $t('formularios.formato_telefono') }}</b>
        </span>
        <span
            v-else-if="mostrarErrorObligatorio"
            class="invalid-feedback mb-4 mt-0 mt-md-3 text-xs"
            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
        >
            <b>{{ $t('formularios.telefono_obligatorio') }}</b>
        </span>
    </div>
</template>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    export default {
        props: ['phone', 'dataCy', 'desactivar', 'forceValidate', 'required'],
        data() {
            return {
                telefono: !isNaN(this.phone) ? this.phone : null,
                isValid: false,
                tocado: false,
                translations: {
                    countrySelectorLabel: this.$t('formularios.codigo_pais'),
                    phoneNumberLabel: this.$t('formularios.telefono'),
                    example: this.$t('formularios.telefono_ejemplo')
                }
            }
        },
        computed: {
            mostrarErrorObligatorio() {
                return this.required && (this.tocado || this.forceValidate) && !this.telefono
            },
            mostrarErrorFormato() {
                return this.telefono && !this.isValid
            }
        },
        methods: {
            formatNumber(infoNumber) {
                this.isValid = infoNumber.isValid
                const formattedNumber = infoNumber.countryCallingCode + infoNumber.nationalNumber

                this.$emit('setNumber', isNaN(formattedNumber) ? null : formattedNumber)

                if(!this.forceValidate && isNaN(formattedNumber)) {
                    this.$emit('validNumber', true)
                } else {
                    this.$emit('validNumber', this.isValid)
                }
            },
            handleInput() {
                this.$emit('onTyping', this.telefono)
            }
        },
        components: { VuePhoneNumberInput }
    }
</script>

<style>
    .country-selector__toggle__arrow[data-v-46e105de] {
        padding-top: 8px;
    }

    .country-selector.lg .country-selector__label[data-v-46e105de] {
        font-size: 10px;
    }

    @media screen and (min-width: 1200px) {
        .country-selector.lg.has-value .country-selector__input[data-v-46e105de] {
            padding-top: 25px;
            height: 62px;
            border-bottom: 1px solid #4c4c45;
        }

        .input-tel.lg .input-tel__input[data-v-e59be3b4] {
            height: 62px;
            border-bottom: 1px solid #4c4c45;
        }
    }
</style>
